const SvgSustainability1 = (props) => (
  <>
    <defs />
    <path
      d="m269.4 140.64-76.79 76.79m0 0c0-49.91-39.68-89.59-89.59-89.59h-38.4v38.4c0 49.91 39.68 89.59 89.59 89.59h38.4v-38.4Zm127.99-89.59v-38.4h-38.4c-49.91 0-89.59 39.68-89.59 89.59v38.4h38.4c49.91 0 89.59-39.68 89.59-89.59ZM192.61 336.02v-80.2l-76.79-76.83M286 360.1c50.82-28.65 88.05-80.05 96.31-142.43C396.25 112.36 322.35 15.66 217.25 1.69c-27.07-3.6-53.56-1.36-78.23 5.75M98 23.9C47.17 52.54 9.95 103.95 1.69 166.33c-13.94 105.31 59.96 202.01 165.06 215.98 27.07 3.6 53.56 1.36 78.22-5.75"
      id="b"
      stroke="#042068"
      strokeMiterlimit={2}
      strokeWidth="3px"
      fill="none"
    />
    <circle cx={96.36} cy={24.1} r={8} fill="#1e62f3" strokeWidth={0} />
    <circle cx={96.36} cy={24.1} r={24} stroke="#021d6c" strokeMiterlimit={10} fill="none" />
    <circle cx={288.26} cy={359.64} r={8} fill="#1e62f3" strokeWidth={0} />
    <circle cx={288.26} cy={359.64} r={24} stroke="#021d6c" strokeMiterlimit={10} fill="none" />
  </>
);

export default SvgSustainability1;
